import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../property';
import { AlertService } from '../../../_services';
import { ApiResponse } from '../../../_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { BathroomService } from './bathroom.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BathroomFormComponent } from './components/bathroom-form/bathroom-form.component';

@Component({
    selector: 'app-bathroom',
    templateUrl: './bathroom.component.html',
    styleUrls: ['./bathroom.component.css'],
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    standalone: false
})



export class BathroomComponent implements OnInit, OnChanges
{

	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private bathroomService: BathroomService,
		private featureService: FeatureService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
	)
	{
	}



	// data
	@Input() shortTermRentalId: number;
	@Input() featuresList = [];
	bathrooms: any;
	apiResponse: ApiResponse;
	formLoading: any;
	formAlert: String;

	ngOnInit()
	{
		this.findBathroomsByShortTermRentalId();
	}

	ngOnChanges(changes: SimpleChanges)
	{

		// update the data if the shortTermRentalId input changes

		// find what property changed
		for (let propName in changes)
		{
			if (propName === 'shortTermRentalId')
			{
				let change = changes[propName];
				this.findBathroomsByShortTermRentalId();
			} else if (propName === 'featuresList')
			{
				// do nothing
			}
		}
	}

	findBathroomsByShortTermRentalId()
	{
		try
		{
			// stop here if form is invalid
			if (!this.shortTermRentalId)
			{
				return;
			}

			this.formLoading = true;

			this.bathroomService.findBathroomsByShortTermRentalId(this.shortTermRentalId)
				.subscribe(
					res =>
					{
						// console.log('bathroom-findBathroomsByShortTermRentalId SUCCESS: ' + JSON.stringify(res));
						this.apiResponse = res;
						this.bathrooms = res.data.bathrooms;

					},
					err =>
					{
						console.log('bathroom-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	openFormAdd()
	{
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data
		dialogConfig.data = {
			shortTermRentalId: this.shortTermRentalId,
			title: 'Add Bathroom'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(BathroomFormComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(

			data =>
			{
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addBathroom(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/**
	 *
	 * EventEmitter Callbacks
	 * To edit the list show add/edit/delete in real time
	 *
	 */

	addBathroom(event)
	{
		console.log('Adding Bathroom: ' + event);
		// if we don't have a Bathroom array yet...
		if (!this.bathrooms)
		{
			this.bathrooms = [];
		}
		this.bathrooms.push(event);
		this.formAlert = 'Bathroom #' + event.bathroomId + ' added.';
	}


	updateBathroom(event)
	{
		console.log('Updating Bathroom: ' + JSON.stringify(event));
		let itemIndex = this.bathrooms.findIndex(item => item.bathroomId === event.bathroomId);
		this.bathrooms[itemIndex] = event;
	}


	deleteBathroom(event)
	{
		console.log('Removing Bathroom: ' + event);
		this.bathrooms = this.bathrooms.filter(item => item !== event);
	}
}
